export const regExpEscape = (literal_string = '') => {
  return literal_string.replace(/[-[\]{}()*+!<=:?.\/\\^$|#\s,]/g, '\\$&') //eslint-disable-line
}
